import React from 'react';
import { useSetAtom, useAtom } from 'jotai';
import { Typography, Button, Box, Modal } from '@mui/material';
import { ApiHardwares } from '../../../api/apiHardwares';
import { isBackdropOpenAtom, snackbarPropsAtom } from '../../../atoms';
import { instrumentListVersionAtom } from '../../../atoms/instrumentAtoms';

const ModalContent = React.forwardRef<
  typeof Box,
  { children: React.ReactNode }
>(({ children }, ref) => {
  return (
    <Box
      ref={ref}
      flexDirection={'column'}
      rowGap={3}
      tabIndex={-1}
      sx={{
        display: 'flex',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        minWidth: '500px',
        bgcolor: 'background.paper',
        border: 2,
        borderColor: 'black',
        borderRadius: '3px',
      }}
    >
      {children}
    </Box>
  );
});

const ModalButton = (props: {
  label: string;
  color:
    | 'inherit'
    | 'primary'
    | 'secondary'
    | 'success'
    | 'error'
    | 'info'
    | 'warning'
    | undefined;
  onClick: () => void;
}) => {
  return (
    <Button
      variant='contained'
      color={props.color}
      sx={{ width: '150px' }}
      onClick={props.onClick}
    >
      {props.label}
    </Button>
  );
};

const UnregisterModal = (props: {
  deleteSerial: string;
  isUnregisterModalOpen: boolean;
  setIsUnregisterModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const { deleteSerial, isUnregisterModalOpen, setIsUnregisterModalOpen } =
    props;
  const setIsBackdropOpen = useSetAtom(isBackdropOpenAtom);
  const setSnackbarPropsAtom = useSetAtom(snackbarPropsAtom);
  const [version, setVersion] = useAtom(instrumentListVersionAtom);

  const onClickUnregisterSerial = async () => {
    setIsBackdropOpen(true);
    setIsUnregisterModalOpen(false);

    await ApiHardwares.delete(deleteSerial)
      .then(() => {
        setVersion(version + 1);
        setSnackbarPropsAtom({
          isOpen: true,
          message: '器械を削除しました。',
          type: 'success',
        });
      })
      .catch((error) => {
        console.log(error);
        setSnackbarPropsAtom({
          isOpen: true,
          message: '器械の削除に失敗しました。',
          type: 'error',
        });
      })
      .finally(() => {
        setIsBackdropOpen(false);
      });
  };

  return (
    <Modal
      open={isUnregisterModalOpen}
      onClose={() => {
        setIsUnregisterModalOpen(false);
      }}
      aria-labelledby='modal-modal-title'
      aria-describedby='modal-modal-description'
    >
      <ModalContent>
        <Box
          display={'flex'}
          alignItems={'center'}
          justifyContent={'center'}
          flexDirection={'column'}
          columnGap={15}
        >
          <Box
            display={'flex'}
            alignItems={'center'}
            flexDirection={'column'}
            marginBottom={1}
            gap={3}
            margin={5}
          >
            <Typography variant='h5' color={'black'}>
              登録を解除しますか？
            </Typography>
            <Typography variant='body1' color={'red'}>
              ※登録を解除しても保証期間は変更されません
            </Typography>
          </Box>
        </Box>
        <Box
          display={'flex'}
          justifyContent={'center'}
          columnGap={5}
          marginBottom={5}
        >
          <ModalButton
            label='決定'
            color='primary'
            onClick={onClickUnregisterSerial}
          />
          <ModalButton
            label='キャンセル'
            color='inherit'
            onClick={() => {
              props.setIsUnregisterModalOpen(false);
            }}
          />
        </Box>
      </ModalContent>
    </Modal>
  );
};

export default UnregisterModal;
